import styled, { keyframes } from 'styled-components';

// Styled components
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
export const MainContainer = styled.div` 
  padding-top:25px;
  padding-bottom:100px;
  overflow-y:scroll;
  animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */
  
`;
export const BoxContainer = styled.div` 
  display:flex;
  flex-direction:row; 
  gap: 3.5rem;

`;


export const Box = styled.div`  
display:flex;
flex-direction:column;
width:28.3%;
height: 19em;
flex-shrink: 0;
border-radius: 12px;
background: #FFF;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 8px;
    animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */
   
`;
export const BoxTitleContainer = styled.div`  
display:flex;
flex-direction:row;
width:100%

   
`;
export const BoxTitle = styled.div` 
margin-top:20px;
margin-left:20px;
color: #000;
font-family: Product Sans;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: normal;
min-width:50%;  
`;

export const BoxStats = styled.div`  
 
color: #000;
font-family: Product Sans;
font-size: 32px;
font-style: normal;
font-weight: 700;
line-height: normal; 
min-width:40%;  
text-align:right;
padding-right:15px;
margin-top: 13px;
`;
export const StatusBox = styled.div`  
display:flex;
flex-direction:row;  

`;


export const Status = styled.div`  
padding-left:17px; 
margin-top:21px; 
color: #7B7B7B;
font-family: Product Sans;
font-size: 10px;
font-style: normal;
font-weight: 400;
line-height: 14.265px; /* 142.651% */
letter-spacing: -0.178px;
`;

export const ProgressContainer = styled.div` 
margin-top:25px; 
margin-left:2px; 
border-radius: var(--br-5xs);
background-color: var(--color-whitesmoke-200);
width: 95px;
height: 8px; 
`;

export const ProgressBar = styled.div` 

height: 8px;
flex-shrink: 0;
border-radius: 8px;
background: #4285F4;
`;
export const BoxGraphContainer = styled.div`  
display:flex;
flex-direction:row;
width:100% ;
padding-top:15px; 
`;
export const GraphContainer = styled.div`  
margin:auto;
display:flex;
flex-direction:column;
animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */
`;
export const GraphHeading = styled.div`  
text-align:right;
letter-spacing: -0.18px;
  line-height: 14.27px;
  color: #000;
  font-family: var(--font-product-sans);
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 14.265px; /* 142.651% */
letter-spacing: -0.178px;

`;

export const Graph = styled.div`  
border-radius: 50%;
background-color: var(--color-whitesmoke-200);
width: 5.7em;
height: 5.5em;
padding:5px;

`;

export const BoxFooter = styled.div`  
display:flex;
flex-direction:row;
animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */
`;
export const BoxFooterTitle = styled.div`  
width:50%; 
cursor: pointer;
    font-size: var(--font-size-3xs);
    color: var(--color-black);
    letter-spacing: -0.18px;
    line-height: 14.27px;
    padding-top: 25px;
    padding-left:26px; 
`;
export const BoxFooterButtonContainer = styled.div`  
width:50%; 
cursor: pointer;
    font-size: var(--font-size-3xs);
    color: var(--color-black);
    letter-spacing: -0.18px;
    line-height: 14.27px;
    padding-top: 25px;
    padding-left:26px; 
`;
export const GotoScanButton = styled.div` 
float:right;  
margin-right:30px; 
cursor: pointer;
border-radius: var(--br-11xl);
background-color: var(--color-black);
width: 44px;
height: 20px;
`;
export const ButtonIcon = styled.img` 
padding-top: 6.32px;
padding-left: 13px;
width: 17.5px;
height: 7.36px; 
`;

export const ActiveCarContainer = styled.div` 
margin: 7%;
margin-left: 31%;
 
`;
export const ActiveCar = styled.img` 
width: 153.37px;
    height: 93px;
    object-fit: cover;
`;
export const BoxFooterActiveTitle = styled.div`  
width:50%;  
    letter-spacing: -0.18px;
    line-height: 14.27px;
    padding-top: 2px;
    padding-left:26px; 
    font-size: var(--font-size-3xs);
    color: var(--color-gray-100);
`;
export const BoxFooterActiveCarOwner = styled.div`  
width:50%;  
    letter-spacing: -0.18px;
    line-height: 14.27px;
    padding-top: 2px;
    padding-right:26px; 
    font-size: var(--font-size-3xs);
    color: var(--color-gray-100);
    text-align:right;
`;

export const StyledNotification = styled.div`
  background-color: #4CAF50;
  color: white;
  padding: 15px;
  border-radius: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  min-width:26.7%;
  max-width:26.7%;
  font-size:11px
  
`;


export const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export  const OuterCircleWrapper = styled.div`
  position: relative;
  width: 70px; /* Adjust the width as needed */
  height: 70px; /* Adjust the height as needed */
`;

export  const InnerSpinner = styled.div`
  position: absolute;
  top: 20%;
  left: 20%;
  transform: translate(-50%, -50%);
  width: 36px; /* Adjust the width and height as needed */
  height: 36px;
  border-radius: 50%;
  border: 2px solid black; /* Set the color for the spinner */
  border-top: 2px solid transparent;
  animation: ${spin} 1s linear infinite;
`;





